import { UseFormReturn } from 'react-hook-form';
import GeneralInformation, { GeneralInformationData } from './Generalnformation';
import GeneralConception, { GeneralConceptionData } from './GeneralConception';
import Typology, { TypologyData } from './Typology';
import { Unit } from '../utils';

type QuickSimulationProps = {
  quickSimulation: QuickSimulationData;
  ddv: number;
  availableUnits: Unit[];
  refUnit: Unit;
  form: UseFormReturn;
};

export type QuickSimulationData = {
  general: GeneralInformationData;
  generalConception: GeneralConceptionData;
  typology: TypologyData;
};

function QuickSimulation({
  quickSimulation,
  ddv,
  availableUnits,
  refUnit,
  form,
}: QuickSimulationProps) {
  return (
    <div
      style={{
        display: 'flex',
        columnGap: '20px',
      }}
    >
      <div>
        <GeneralInformation
          general={quickSimulation.general}
          ddv={ddv}
          availableUnits={availableUnits}
          refUnit={refUnit}
          form={form}
        />
        <Typology typology={quickSimulation.typology} form={form} />
      </div>
      <GeneralConception
        generalConception={quickSimulation.generalConception}
        form={form}
      />
    </div>
  );
}

export default QuickSimulation;
